import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class DownloadOrganisationOverdueBillDocument extends Relay.Mutation {
    static propTypes = {
        id: PropTypes.string.isRequired, // Relay GID of OrganisationOverdueBill
        format: PropTypes.string.isRequired, // 'pdf' | 'isdoc'
    };

    getMutation() { return Relay.QL`mutation { downloadOrganisationOverdueBillDocument }`; }

    getVariables() {
        return {
            id: this.props.id,
            format: this.props.format,
        };
    }

    getFatQuery() {
        // We only need url
        return Relay.QL`fragment on DownloadOrganisationOverdueBillDocumentPayload { url }`;
    }

    getConfigs() {
        return [{ type: 'REQUIRED_CHILDREN', children: [this.getFatQuery()] }];
    }
}


